import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCnA-AjTxO8Y6BdHo9CKwZSLOrtXryzZnk",
  authDomain: "hollas-price-portal.firebaseapp.com",
  projectId: "hollas-price-portal",
  storageBucket: "hollas-price-portal.appspot.com",
  messagingSenderId: "1039107084906",
  appId: "1:1039107084906:web:921f6cdbf4955a7dedb013"
};

const app = initializeApp(firebaseConfig);
export const database = getAuth(app);